import React from 'react';
import { Section } from './ui/Section';
import { AlertCircle, HeartCrack, BatteryWarning, TrendingDown } from 'lucide-react';
export function ProblemEscalation() {
  return <Section background="cream" data-id="element-1174">
      <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-1175">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-1176">
          La hinchazón no es solo estética. <br data-id="element-1177" />
          <span className="text-red-700" data-id="element-1178">Está destruyendo tu confianza.</span>
        </h2>
        <p className="text-lg text-gray-600 mb-8" data-id="element-1179">
          El problema empeora con cada década. Reconoce dónde estás:
        </p>

        {/* Age-based escalation */}
        <div className="grid md:grid-cols-3 gap-6 mb-12 text-left" data-id="element-1180">
          <div className="bg-orange-50 border-2 border-orange-200 rounded-xl p-6" data-id="element-1181">
            <div className="flex items-center gap-2 mb-3" data-id="element-1182">
              <TrendingDown className="w-5 h-5 text-orange-600" data-id="element-1183" />
              <span className="font-bold text-orange-900 text-lg" data-id="element-1184">
                A partir de los 30
              </span>
            </div>
            <p className="text-gray-700 text-sm leading-relaxed" data-id="element-1185">
              Tu metabolismo empieza a ralentizarse. Esos kilos que antes
              perdías fácilmente ahora se quedan pegados. La ropa empieza a
              apretar.
            </p>
          </div>

          <div className="bg-red-50 border-2 border-red-300 rounded-xl p-6" data-id="element-1186">
            <div className="flex items-center gap-2 mb-3" data-id="element-1187">
              <TrendingDown className="w-5 h-5 text-red-600" data-id="element-1188" />
              <span className="font-bold text-red-900 text-lg" data-id="element-1189">
                A partir de los 45
              </span>
            </div>
            <p className="text-gray-700 text-sm leading-relaxed" data-id="element-1190">
              Los cambios hormonales hacen que la grasa se acumule en el
              abdomen. Ya no es solo peso, es grasa visceral resistente que no
              responde a dietas.
            </p>
          </div>

          <div className="bg-red-100 border-2 border-red-400 rounded-xl p-6" data-id="element-1191">
            <div className="flex items-center gap-2 mb-3" data-id="element-1192">
              <TrendingDown className="w-5 h-5 text-red-700" data-id="element-1193" />
              <span className="font-bold text-red-900 text-lg" data-id="element-1194">
                A partir de los 60
              </span>
            </div>
            <p className="text-gray-700 text-sm leading-relaxed" data-id="element-1195">
              El metabolismo se ralentiza drásticamente y la inflamación crónica
              se instala. No es tu culpa, pero ignorarlo tiene consecuencias
              reales para tu salud.
            </p>
          </div>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-1196">
        {[{
        icon: AlertCircle,
        title: 'Incomodidad Física',
        desc: 'Esa sensación constante de pesadez que te impide moverte con agilidad y disfrutar de tus actividades favoritas.'
      }, {
        icon: HeartCrack,
        title: 'Impacto en la Pareja',
        desc: 'La falta de confianza en tu cuerpo puede crear distancias invisibles en tus relaciones más importantes.'
      }, {
        icon: BatteryWarning,
        title: 'Energía Drenada',
        desc: 'La inflamación crónica roba tu vitalidad, dejándote cansado incluso después de dormir bien.'
      }].map((item, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 text-center hover:shadow-md transition-shadow" data-id="element-1197">
            <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-1198">
              <item.icon className="w-8 h-8 text-red-600" data-id="element-1199" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1200">
              {item.title}
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-1201">{item.desc}</p>
          </div>)}
      </div>
    </Section>;
}